import OImage from 'components/reusable/OImage'
import { isEmpty, startCase } from 'lodash'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BiArrowBack } from 'react-icons/bi'
import defaultDeveloperImage from '../../assets/images/defaultDeveloperImage.jpg'
import { useLocation, useNavigate } from 'react-router-dom'
import helper from 'utils/helpers'

const ViewProject = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const [item] = useState(location?.state?.item)
  return (
    <>
      <div
        className='relative pt-6 pl-6 flex  items-center cursor-pointer'
        onClick={() => navigate(-1)}
      >
        <BiArrowBack className='h-8 w-8 border text-white py-1 rounded-md bg-[#6236FF] cursor-pointer mb-2' />
        <span className='ml-2'>{t('O_BACK')}</span>
      </div>
      <div className='relative p-6 flex-auto  overflow-x-hidden'>
        <div className=' border-2 rounded-md p-5'>
          <div className='grid grid-cols-5 '>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('PROJECT_ID')}:</strong>
              </div>
              <div>{item?.projectId}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_TITLE')}:</strong>
              </div>
              <div>{startCase(item?.title)}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('DEVELOPER_NAME')}:</strong>
              </div>
              <div>{item?.developerName}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('DEVELOPER_NAME') + t('O_ARABIC')}:</strong>
              </div>
              <div>{item?.developerNameAr}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('DELIVERY_DATE')}:</strong>
              </div>
              <div>{helper.dateFormat(item?.handOverDate)}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('BATHROOMS')}:</strong>
              </div>
              <div className='flex'>
                <div className='mr-2'>
                  {t('MIN')}: {item?.minBathrooms}
                </div>
                <div>
                  {t('MAX')}: {item?.maxBathrooms}
                </div>
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('BEDROOMS')}:</strong>
              </div>
              <div className='flex'>
                <div className='mr-2'>
                  {t('MIN')}: {item?.minBedrooms}
                </div>
                <div>
                  {t('MAX')}: {item?.maxBedrooms}
                </div>
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('GUEST_ROOMS')}:</strong>
              </div>
              <div className='flex'>
                <div className='mr-2'>
                  {t('MIN')}: {item?.minGuestRooms}
                </div>
                <div>
                  {t('MAX')}: {item?.maxGuestRooms}
                </div>
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('LIVING_ROOMS')}:</strong>
              </div>
              <div className='flex'>
                <div className='mr-2'>
                  {t('MIN')}: {item?.minLivingRooms}
                </div>
                <div>
                  {t('MAX')}: {item?.maxLivingRooms}
                </div>
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_PROPERTY_SIZE')}:</strong>
              </div>
              <div className='flex'>
                <div className='mr-2'>
                  {t('MIN')}: {item?.minPropertySize}
                </div>
                <div>
                  {t('MAX')}: {item?.maxPropertySize}
                </div>
              </div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_NEAREST_FACILITIES')}:</strong>
              </div>
              <div>{item?.nearestFacilities}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('PRICE_PER_SQFT')}:</strong>
              </div>
              <div>{item?.pricePerSqFt}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('PROJECT_STATUS')}:</strong>
              </div>
              <div>{item?.projectStatus}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_STARTING_PRICE')}:</strong>
              </div>
              <div>{item?.startingPrice}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('O_STATUS')}:</strong>
              </div>
              <div>{item?.status}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('Developer Image')}:</strong>
              </div>
              <div className='flex justify-start'>
                <OImage
                  src={item?.developerImage}
                  fallbackUrl={defaultDeveloperImage}
                  className='w-24 h-24 m-auto'
                  alt=''
                  style={{ borderRadius: '50%' }}
                />
              </div>
            </div>
          </div>
          <div className='grid grid-cols-3'>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('PAYMENT_PERCENTAGE_DURING_CONSTRUCTION')}:</strong>
              </div>
              <div>{item?.paymentPercentDuringConstruction}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('PAYMENT_PERCENTAGE_ON_BOOKING')}:</strong>
              </div>
              <div>{item?.paymentPercentOnBooking}</div>
            </div>
            <div className='mb-3'>
              <div className=''>
                <strong>{t('PAYMENT_PERCENTAGE_ON_HANDOVER')}:</strong>
              </div>
              <div>{item?.paymentPercentOnHandover}</div>
            </div>
          </div>
          <div className='mb-4 mt-2'>
            <div className=''>
              <strong>{t('AMENITIES')}:</strong>
            </div>
            <div>
              {!isEmpty(item.amenities)
                ? item?.amenities?.map(amenity => amenity?.name).join(', ') +
                  '.'
                : 'N/A'}
            </div>
          </div>
          <div className='mb-4 mt-2'>
            <div className=''>
              <strong>{t('O_DESCRIPTION')}:</strong>
            </div>
            <div>{item?.description || 'N/A'}</div>
          </div>
          <div className='mb-4 mt-2'>
            <div className=''>
              <strong>{t('O_DESCRIPTION') + t('O_ARABIC')}:</strong>
            </div>
            <div>{item?.descriptionAr || 'N/A'}</div>
          </div>
          <div className='mb-4 mt-2'>
            <div className=''>
              <strong>{t('VIDEO')}:</strong>
            </div>
            <div className='flex  mt-5'>
              {item?.video?.length > 0 &&
                item?.video?.map((video, index) => (
                  <div
                    key={index}
                    className='w-[164px] h-[164px] xl:w-[321px] xl:h-[204px] rounded border-2 relative overflow-hidden p-2 mx-2'
                  >
                    <video
                      className='w-full h-full m-auto object-cover'
                      muted
                      width='320'
                      height='240'
                      src={video}
                      controls
                    />
                  </div>
                ))}
            </div>
          </div>

          {item?.photos?.length > 0 && (
            <div className='pt-4'>
              <strong className='pt-6'>{t('Photos')}:</strong>
              <div className='flex flex-wrap'>
                {item?.photos.map((photo, index) => (
                  <div
                    key={index}
                    className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden m-2'
                  >
                    <figure className='w-full h-full'>
                      <OImage
                        src={photo}
                        fallbackUrl='/images/user.png'
                        className='w-full h-full object-cover'
                        alt=''
                      />
                    </figure>
                  </div>
                ))}
              </div>
            </div>
          )}
          {item?.floorPlan?.length > 0 && (
            <div className='pt-4'>
              <strong className='pt-6'>{t('FLOOR_PLAN')}:</strong>
              <div className='flex flex-wrap'>
                {item?.floorPlan.map((photo, index) => (
                  <div className=' px-2' key={index}>
                    <div className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden m-2 mx-0'>
                      <figure className='w-full h-full'>
                        <OImage
                          src={photo?.image}
                          fallbackUrl='/images/user.png'
                          className='w-full h-full object-cover'
                          alt=''
                        />
                      </figure>
                    </div>
                    <div className='mr-2'>
                      <strong>{t('O_TITLE')}: </strong>
                      {photo?.title}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default ViewProject
